var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-end" }, [
    _c("div", { staticClass: "dropdown" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-dark btn-sm",
          attrs: {
            type: "button",
            id: "dropdownMenuButton1",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false",
          },
        },
        [
          _vm.isSubscribedToCurrentTopic
            ? _c("i", { key: "1", staticClass: "fas fa-bell" })
            : _c("i", { key: "2", staticClass: "far fa-bell" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "dropdown-menu",
          attrs: { "aria-labelledby": "dropdownMenuButton1" },
        },
        [
          _c("li", [
            _c(
              "a",
              {
                staticClass: "dropdown-item small fw-semibold",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.notificationsOn.apply(null, arguments)
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-bell me-2" }),
                _vm._v(
                  " " + _vm._s(_vm._f("translate")("Email notifications"))
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "dropdown-item small fw-semibold",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.notificationsOff.apply(null, arguments)
                  },
                },
              },
              [
                _c("i", { staticClass: "far fa-bell me-2" }),
                _vm._v(
                  " " + _vm._s(_vm._f("translate")("In app notifications"))
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }